module.exports = __webpack_public_path__ + "static/media/wallpaper_large.57c36c49.svg";